<h1 mat-dialog-title>Fehler bei Ihrem Zugang</h1>
<mat-dialog-content>
  <div class="icon-bar">
    <mat-icon class="ok">login</mat-icon>
    <div class="dots">
      <div *ngFor="let d of cDots" class="dot"></div>
    </div>
    <mat-icon class="fail">supervised_user_circle</mat-icon>
  </div>

  <p>
    Ihr Zugang funktioniert und Sie haben sich erfolgreich angemeldet.<br>
    Ihnen sind momentan allerdings keine aktiven Mieter zugeordnet.<br>
    Bitte wenden Sie sich an Ihren Hausverwalter.
  </p>

</mat-dialog-content>
<div mat-dialog-actions>
  <button mat-button (click)="close()" cdkFocusInitial>Schließen</button>
</div>
